import { SubscriptionMenuId } from './subscriptionMenuId';
import { SubscriptionPlan } from './subscriptionPlan';

export class SubscriptionMenu {
  private readonly _brand = SubscriptionMenu.name;
  constructor(
    public readonly id: SubscriptionMenuId,
    public readonly plan: SubscriptionPlan,
  ) {}

  // TODO: 本番データのメニューIDベタ書きじゃなくて環境変数化またはDBに属性いれるなどしたい
  // 仮面様の占いサブスクメニュー(480円)
  isKamen480Menu = (): boolean => ['DaT3h3pfBt5SYYPPkbXp'].includes(this.id.value);

  // 仮面様シルバートライアルサブスクメニュー
  isSilverTrialKamenMenu = (): boolean =>
    ['VJD7aomn5GILoz7Ehxeb', 'aKxKpJ1Jy5h1R2YAZXK5'].includes(this.id.value);

  // 仮面様シルバーサブスクメニュー
  isSilverKamenMenu = (): boolean => ['4niklBhEYv5YUjYLwWue', 'Ensg4H0dB4Mk4ZU28Q3L'].includes(this.id.value);

  // 仮面様ゴールドトライアルサブスクメニュー
  isGoldTrialKamenMenu = (): boolean => ['79cDZokunAUK5aI8MLDF'].includes(this.id.value);

  // 仮面様ゴールド旧トライアルサブスクメニュー（昔展開した無料トライアル。現在は展開してない）
  // TODO: DB整理したら消す
  isUnusedGoldTrialKamenMenu = (): boolean => ['RqPCgBAVvi146ZJvnNBT'].includes(this.id.value);

  // 仮面様ゴールドサブスクメニュー
  isGoldKamenMenu = (): boolean => ['NhbNyCUhswKD1hM8y5ME'].includes(this.id.value);

  // 仮面様プラチナサブスクメニュー
  isPlatinumKamenMenu = (): boolean => ['fOAXHzYHEPLersQ1fjFG'].includes(this.id.value);
}
